export enum OrderBillPathEnum {
	OrderBillConfirmation = 'order-bill/confirmation',
}
